import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Auth, onAuthStateChanged } from '@angular/fire/auth';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { EntryService } from 'src/app/services/entry.service';
import { EventService } from 'src/app/services/event.service';
import { Event } from 'src/app/models/event';
import { doc, Firestore, onSnapshot } from '@angular/fire/firestore';
import { Collection } from 'src/app/enums/collection.enum';

@Component({
    selector: 'app-event',
    templateUrl: './event.component.html',
    styleUrls: ['./event.component.scss'],
    standalone: false
})
export class EventComponent implements OnInit, OnDestroy {

  event: any;
  entries: Observable<any[]>;
  id: string;
  signedIn = false;
  isCollapsed = true;
  private firestore = inject(Firestore);
  private auth = inject(Auth);
  private eventSubscription?;
  private authSubscription?;
  user: any;
  constructor(
    private _route: ActivatedRoute,
    private _eventService: EventService,
    private _entryService: EntryService,
  ) {
    this.id = this._route.snapshot.paramMap.get('id');
    this.authSubscription = onAuthStateChanged(this.auth, (u) => {
      if (u) {
        // User is signed in, see docs for a list of available properties
        // https://firebase.google.com/docs/reference/js/auth.user
        this.signedIn = true
        this.user = u
        // ...
      } else {
        // User is signed out
        this.signedIn = false
        this.user = null;
      }
    });
    const docRef = doc(this.firestore, Collection.Events, this.id);
    this.eventSubscription = onSnapshot(docRef, (doc) => {
      this.event = Object.assign(new Event, doc.data());
    });
  }
  ngOnInit(): void {
    this.event = this._eventService.get(this.id);
    this.getEntries();
  }
  ngOnDestroy(): void {
    if(this.eventSubscription) {
      // unsubscribes
      this.eventSubscription();
    }
    if(this.authSubscription) {
      // unsubscribes
      this.authSubscription();
    }
  }
  async getEntries(){
    this.entries = this._entryService.getByEvent(this.id);
  }
  startEvent(){
    const sub = this.entries.subscribe(x => {
      const entryIds = x.map(y => y.id);
      if(entryIds.length){
        this._entryService.startEntries(this.id, entryIds);
        sub.unsubscribe();
      }
    })
  }
  async resetEvent(){
    const sub = this.entries.subscribe(x => {
      const entryIds = x.map(y => y.id);
      if(entryIds.length){
        this._entryService.resetEntries(this.id, entryIds);
        sub.unsubscribe();
      }
    })
  }
  toggleLock(){
    this.event.locked = !this.event.locked;
    this._eventService.update(this.event);
  }
  isLocked(){
    return this.event?.locked == true;
  }
}
